import gql from 'graphql-tag';

export default gql`
  mutation meUpdate($input: MeUpdateInput!) {
    meUpdate(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
